import { API_BASE_URL_ENV } from "../../jsx/common/common";
import BaseService from "../BaseService";

const apiEndpoint = API_BASE_URL_ENV() + "/vacations";

export default class VacationsService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
}
